const LANGUAGE_STORAGE_KEY = 'ESPRIT_CLIENT_LANGUAGE_SETTING';

export const persistLanguage = (language: string) => localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
export const loadLanguage = () => localStorage.getItem(LANGUAGE_STORAGE_KEY);

export default {
    persistLanguage,
    loadLanguage,
};
